import moduleStepState from './moduleStepState';
const { steps } = moduleStepState;
export default {
  incrementCurrentStep: ({ commit }) => commit("INCREMENT_CURRENT_STEP"),

  decrementCurrentStep: ({ commit }) => commit("DECREMENT_CURRENT_STEP"),

  updateCurrentStep: ({ commit }, payload) =>
    commit("UPDATE_CURRENT_STEP", payload),

  completeStep: ({ commit }) => commit("COMPLETE_STEP"),

  updateBasicFormSubmit: ({ commit }, payload) =>
    commit("UPDATE_BASIC_FORM_SUBMIT", payload),

  parseStepsInformation: ({ dispatch }, payload) => {
    const {
      basic,
      address,
      talent,
      formations,
      experiences,
      languages,
      skills,
      professional_profile
    } = payload["data"].data;

    dispatch("basicInfo/store", { ...basic }, { root: true });
    dispatch("address/setAddress", { ...address }, { root: true });
    dispatch("formation/index", formations, { root: true });
    dispatch("experience/index", experiences, { root: true });
    dispatch("language/index", languages, { root: true });
    dispatch("skill/index", skills, { root: true });
    dispatch("talent/addTalent", talent, { root: true });
    dispatch(
      "professional_profile/addProfessionalProfile",
      professional_profile,
      { root: true }
    );

    return payload;
  },

  perfomSucessfullResponse: ({ dispatch }, payload) => {
    let data = {};

    if (payload.data !== undefined || payload.data !== null)
      data = { ...payload["data"].data };

    if (data !== undefined || data !== null) {
      Object.keys(data).map(key => {
        switch (key) {
          case "basicInfo":
            dispatch("basicInfo/setBasic", { ...data[key] }, { root: true });
            break;
          case "address":
            dispatch("address/setAddress", { ...data[key] }, { root: true });
            break;
          case "formations":
            data[key].map(
              async item =>
                await dispatch("formation/update", { ...item }, { root: true })
            );
            break;
          case "experiences":
            data[key].map(
              async item =>
                await dispatch("experience/index", { ...item }, { root: true })
            );
            break;
          case "languages":
            data[key].map(
              async item =>
                await dispatch("language/index", { ...item }, { root: true })
            );
            break;
          case "skills":
            data[key].map(
              async item =>
                await dispatch("skill/index", { ...item }, { root: true })
            );
            break;

          default:
            break;
        }
      });
    }
  },

  completeStepsAfterParse: async ({ commit, state, rootGetters }) => {
    state.steps.map(async (step, index) => {
      if (!rootGetters["basicInfo/emptyBasic"] && index == 1)
        await commit("COMPLETE_STEPS_AFTER_PARSER", { index });
      if (!rootGetters["basicInfo/emptyCurriculumn"] && index == 2)
        await commit("COMPLETE_STEPS_AFTER_PARSER", { index });
      if (!rootGetters["address/emptyAddress"] && index == 3)
        await commit("COMPLETE_STEPS_AFTER_PARSER", { index });
      if (!rootGetters["experience/emptyExperience"] && index == 4)
        await commit("COMPLETE_STEPS_AFTER_PARSER", { index });
      if (!rootGetters["formation/emptyFormation"] && index == 5)
        await commit("COMPLETE_STEPS_AFTER_PARSER", { index });
      if (!rootGetters["language/emptyLanguage"] && index == 6)
        await commit("COMPLETE_STEPS_AFTER_PARSER", { index });
      if (!rootGetters["skill/emptySkill"] && index == 7)
        await commit("COMPLETE_STEPS_AFTER_PARSER", { index });
    });
  },

  clearStepsState: ({ commit }) => {
    const stepsCopy = JSON.parse(JSON.stringify(steps));
    commit("CLEAR_CURRENT_STEP", 0);
    commit("CLEAR_SECOND_STEP", 0);
    commit("CLEAR_STEP_STEP", { progress: 10 });
    commit("CLEAR_STEPS", stepsCopy);
    commit("CLEAR_BASIC_FORM_SUBMIT", { trigger: false, goTo: undefined });
  }
};
